"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAlertWarning = exports.DmsAlertSuccess = exports.DmsAlertSecondary = exports.DmsAlertPrimary = exports.DmsAlertLight = exports.DmsAlertInfo = exports.DmsAlertDark = exports.DmsAlertDanger = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A customizable alert component styled to match Bootstrap alert classes using Material-UI.
 * @component
 * @param {Object} props
 * @param {string} props.type - The type of alert ('alert-primary', 'alert-secondary', 'alert-success',
 * 'alert-danger', 'alert-warning', 'alert-info', 'alert-light', 'alert-dark').
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
const DmsAlert = _ref => {
  let {
    type,
    message
  } = _ref;
  let severity;
  switch (type) {
    case 'alert-primary':
      severity = 'primary';
      break;
    case 'alert-secondary':
      severity = 'secondary';
      break;
    case 'alert-success':
      severity = 'success';
      break;
    case 'alert-danger':
      severity = 'error';
      break;
    case 'alert-warning':
      severity = 'warning';
      break;
    case 'alert-info':
      severity = 'info';
      break;
    case 'alert-light':
      severity = 'light';
      break;
    case 'alert-dark':
      severity = 'dark';
      break;
    default:
      severity = 'info';
  }

  // Custom styling based on severity type
  const StyledAlert = (0, _material.styled)(_material.Alert)(_ref2 => {
    let {
      theme
    } = _ref2;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, severity === 'primary' && {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "& .MuiAlert-icon": {
        display: "none"
      }
    }), severity === 'secondary' && {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      "& .MuiAlert-icon": {
        display: "none"
      }
    }), severity === 'light' && {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.primary,
      "& .MuiAlert-icon": {
        display: "none"
      }
    }), severity === 'dark' && {
      backgroundColor: theme.palette.grey[900],
      color: theme.palette.common.white,
      "& .MuiAlert-icon": {
        display: "none"
      }
    });
  });
  return /*#__PURE__*/_react.default.createElement(StyledAlert, {
    severity: severity === 'primary' || severity === 'secondary' ? undefined : severity
  }, message);
};

/**
 * Displays a primary styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
const DmsAlertPrimary = _ref3 => {
  let {
    message
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-primary",
    message: message
  });
};

/**
 * Displays a secondary styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertPrimary = DmsAlertPrimary;
const DmsAlertSecondary = _ref4 => {
  let {
    message
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-secondary",
    message: message
  });
};

/**
 * Displays a success styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertSecondary = DmsAlertSecondary;
const DmsAlertSuccess = _ref5 => {
  let {
    message
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-success",
    message: message
  });
};

/**
 * Displays an error styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertSuccess = DmsAlertSuccess;
const DmsAlertDanger = _ref6 => {
  let {
    message
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-danger",
    message: message
  });
};

/**
 * Displays a warning styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertDanger = DmsAlertDanger;
const DmsAlertWarning = _ref7 => {
  let {
    message
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-warning",
    message: message
  });
};

/**
 * Displays an info styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertWarning = DmsAlertWarning;
const DmsAlertInfo = _ref8 => {
  let {
    message
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-info",
    message: message
  });
};

/**
 * Displays a light styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertInfo = DmsAlertInfo;
const DmsAlertLight = _ref9 => {
  let {
    message
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-light",
    message: message
  });
};

/**
 * Displays a dark styled alert message.
 * @component
 * @param {Object} props
 * @param {string} props.message - The message to display in the alert.
 * @returns {JSX.Element}
 */
exports.DmsAlertLight = DmsAlertLight;
const DmsAlertDark = _ref0 => {
  let {
    message
  } = _ref0;
  return /*#__PURE__*/_react.default.createElement(DmsAlert, {
    type: "alert-dark",
    message: message
  });
};
exports.DmsAlertDark = DmsAlertDark;